export default __webpack_public_path__ + "c92dc759e815810b40dab26c973a1899.png";